$(function () {
    var modalFun = new modalFunObj() || '';
    let obj = {spec_req_arr:[],std_tag_arr:[]};
    $(document).on('click',function(){ 
        $('.address-record').hide()
        $('.price-details-box').fadeOut()
        $('.citys-select').hide()
        $('.time-box').hide()
    })
    let height = parseInt($(document).height()/100*30);
    $(window).scroll(function(){
        if(height<$(document).scrollTop()){
            $('#footer').css('position','relative').css('margin-bottom','50px');
            $('.footer2').css('position','relative');
        }else{
            $('#footer').css('position','fixed').css('margin-bottom','0');
            $('.footer2').css('position','fixed');
        }
    })
    getCityList();
    getDefaultAddressXcx()
    $('.header-tag').on('click',function(){
        $(this).addClass('act').siblings().removeClass('act');
        if($(this).text()=='货拉拉'){
            $('.logistics-main').show().siblings().hide();
            $('#footer').show().siblings('.footer2').hide();
        }else{
            $('.chain-main').show().siblings().hide();
            $('.footer2').show().siblings('#footer').hide();
        }
    })
    $('.order-return').on('click',function(){
        $('.logistics-order').hide().siblings('.logistics-main').show();
    })
    $('.city-cilck').on('click',function(e){
        e.stopPropagation();
        $('.citys-select').toggle();
    })
    $('.citys-select').on('click',function(e){
        e.stopPropagation();
    })
    $('.citys-select').on('click','.citys-item',function(){
        $('#cityName').text($(this).text()).data('id',$(this).data('id'));
        $(this).addClass('act').siblings().removeClass('act').parents('.citys-select').hide();
        getCityCar($(this).data('id'))
    })
    let distance=0;
    $('.trucks-box').on('click','.move',function(){
        let length = -($('#trucksList li').length-4)*240;
        $(this).hasClass('icon-arrow-right')?distance=distance-240:distance=Number(distance)+240;
        $('#trucksList').animate({marginLeft:distance})
        distance==0?$(this).removeClass('move'):$('.icon-arrow-left').addClass('move');
        distance==length?$(this).removeClass('move'):$('.icon-arrow-right').addClass('move');
    })
    $('.trucks-box').on('click','.trucks-item',function(){
        $('.transparent').show();
        $(this).children('.transparent').hide();
        obj.order_vehicle_id=$(this).data('id');
        getEvaluation()
    })
    $('.order-address').on('click','.move',function(){
        let length = -($('#addressList').width()-$('.address-slide').wideh());
        $(this).hasClass('icon-arrow-right')?distance=distance-250:distance=Number(distance)+250;
        $('#addressList').animate({marginLeft:distance})
        distance==0?$(this).removeClass('move'):$('.icon-arrow-left').addClass('move');
        distance==length?$(this).removeClass('move'):$('.icon-arrow-right').addClass('move');
    })
    $('.address-btn').on('click',function(){
        $('.address-spot').removeClass('last');
        $(this).before('<div class="address-item"><span class="address-spot last"></span><input class="address-input" type="text" placeholder="按此输入目的地"><em class="address-line"></em><ul class="address-record" style="display: none;"></ul></div>')
        // $(this).prev().children('.address-spot').addClass('last');
    })
    $('.address-box').on('click','.icon-iconfonticonfontwarn',function(){
        $(this).parent().siblings('.address-input').show().val('');
        $(this).parent().remove();
        $('.address-item').length>2?$('.address-item').eq(1).remove():'';
    })
    $('.address-box').on('input properchange','.address-input',function(e){
        e.stopPropagation();
        let that=  $(this);
        $.ajax({
            type:'post',
            url:jkas.url('/wxxcx/hllECitySearch'),
            dataType:'json',
            data:{nonce_str:parseInt(Math.random() * (1000000 - 100000 + 1) + 100000),kw:that.val()},
            success:function(res){
                if(res.code==10){
                    let htm ='',items=res.data.poi;
                    for(let i =0;i<items.length;i++){
                        htm+=`<li class="address-record-item">
                                <i class="iconfont icon-dingwei"></i>
                                <div class="address-list">`+items[i].name+
                                `<p class="address-details" data-city="`+items[i].city+`" data-name="`+items[i].name+`" data-id="`+items[i].city_id+`" data-lat="`+items[i].location.lat+`" data-lon="`+items[i].location.lon+`">`+items[i].address+`</p></div>
                            </li>`   
                    }
                    that.siblings('.address-record').empty().append(htm).show()
                }
            }
        })
    })
    $('.address-box').on('click','.address-record-item',function(){
        $(this).parent().siblings('input').hide();
        $(this).parent().before('<div class="address-list"><i class="iconfont icon-iconfonticonfontwarn"></i>'+$(this).children('div').html()+'</div>')
        let arr = [],addr=[];
        $('.address-item').each(function(i,item){
            let ele = $(item).children('.address-list').children('.address-details');
            arr.push({lat:ele.data('lat'),lon:ele.data('lon'),city_id:ele.data('id')})
            addr.push({lat_lon:{lat:ele.data('lat'),lon:ele.data('lon')},name:ele.data('name'),
            addr:ele.text(),city_id:ele.data('id'),city_name:ele.data('city'),
            district_name:'',house_number:'',contact_name:'',contact_phone_no:''})
        })
        obj.lat_lon_arr = arr;
        obj.addr_info = addr;
        getEvaluation()
    })
    $('.driving-time').on('click',function(){
        $(this).val()==1?$('.day').show():$('.day').hide();
    })
    layui.use('laydate', function(){
        var laydate = layui.laydate;
        var myDate = new Date();
        let year = myDate.getFullYear(),month = myDate.getMonth()+1;
        laydate.render({
            elem: '#time'
            ,eventElem: '.date-icon'
            ,trigger: 'click'
            ,theme: 'grid'
            ,type: 'datetime'
            ,format: 'yyyy-MM-dd HH:mm'
            ,btns: []
            ,min: 0
            ,max: 4
            ,ready:function(){
                $('.layui-laydate-footer').empty()
            }
            ,change:function(value,date){
                if(year==date.year&&month==date.month){
                    $('.layui-laydate-footer').empty().append('<span class="btns">返回日期</span>')
                    $('.layui-laydate-main').addClass('laydate-time-show')
                    $('.laydate-set-ym').append('<span class="laydate-time-text">选择时间</span>')
                    $.ajax({
                        type:'post',
                        url:jkas.url('/wxxcx/getHllTime'),
                        dataType:'json',
                        success:function(res){
                            if(res.code==10){
                                let times;
                                let htm = `<ul class="layui-laydate-list laydate-time-list">
                                <li><p>时</p><ol class="h-time">`
                                for(let i = 0;i<res.data.length;i++){
                                    if(timeFormat(res.data[i].stime,'dd')==date.date){
                                        times = res.data[i].h_time;
                                        let h_time = res.data[i].h_time;
                                        let initial = res.data[i].val=='今天'?1:0;
                                        for(let j = initial;j<h_time.length;j++){
                                            let act = j == initial?'layui-this':''
                                            htm+='<li class="'+act+'">'+h_time[j].val+'</li>'
                                        }
                                        htm+=`</ol></li><li><p>分</p><ol class="m-time">`;
                                        let m_time = h_time[initial].m_time;
                                        for(let k = 0;k<m_time.length;k++){
                                            htm+='<li class>'+m_time[k].val+'</li>'
                                        }
                                    }
                                }
                                htm+=`</ol></li><li><p>秒</p><ol><li>00</li></ol></li></ul>`;
                                $('.layui-laydate-content').append(htm)
                                $('.laydate-time-list ol').on('click','li',function(){
                                    $(this).addClass('layui-this').siblings().removeClass('layui-this');
                                    if($(this).parent().hasClass('m-time')){
                                        let stamp = date.year+'-'+date.month+'-'+date.date+' '+$('.h-time .layui-this').text()+
                                        ':'+$('.m-time .layui-this').text();
                                        $('#time').val(stamp)
                                        let myDate = new Date(stamp);
                                        obj.order_time=myDate.getTime()/1000;
                                        $('#layui-laydate1').hide()
                                    }else{
                                        let initial = date.date==myDate.getDate()?$(this).index()+1:$(this).index();
                                        let htm ='';
                                        for(let i = 0;i<times[initial].m_time.length;i++){
                                            htm+='<li class>'+times[initial].m_time[i].val+'</li>'
                                        }
                                        $('.m-time').empty().append(htm)
                                    }
                                })
                            }
                        }
                    })
                }else{
                    year=date.year;
                    month=date.month;
                }
                $('.btns').on('click',function(){
                    $('.laydate-time-list').empty().hide();
                    $(this).hide();
                    $('.laydate-time-text').hide()
                    $('.layui-laydate-main').removeClass('laydate-time-show')
                })
            }
        });
    });
    // $('.day .icon-icon_xuanquriqi').on('click',function(){
    //     $('#time').focus().click()
    // })
    $('#additionalDemand').on('click','.check-input',function(){
        let arr=[];
        $('.check-input:checked').each(function(i,item){
            arr.push($(item).val())
        })
        obj.std_tag_arr = arr;
        getEvaluation()
    })
    $('.price-details').on('click',function(e){
        e.stopPropagation();
        $('.price-details-box').fadeToggle()
    })
    let nonce_str = parseInt(Math.random() * (1000000 - 100000 + 1) + 100000);
    $('.trucks-submit').on('click',function(){
        let time = obj.order_time?obj.order_time:Math.round(new Date().getTime()/1000);
        $.ajax({
            type:'post',
            url:jkas.url('/wxxcx/hllEOrderRequest'),
            dataType:'json',
            async: false,
            data:{
                nonce_str:nonce_str,
                city_id:obj.city_id,
                city_info_revision:obj.city_info_revision,
                order_vehicle_id:obj.order_vehicle_id,
                std_tag_arr:JSON.stringify(obj.std_tag_arr),
                spec_req_arr:JSON.stringify(obj.spec_req_arr),
                addr_info:JSON.stringify(obj.addr_info),
                order_time:time,
                total_price_fen:obj.total_price_fen,
                contact_name:$('#contactName').val(),
                contact_phone_no:$('#contactPhoneNo').val(),
                order_reason:'',
                remark:$('.information-textarea').val(),
                order_sn:'',
                sale_plat:''
            },
            success:function(res){
                layer.msg(res.rep_msg)
                if(res.code==10){
                    getOrderDetail(res.wb_no)
                }else{
                    nonce_str = parseInt(Math.random() * (1000000 - 100000 + 1) + 100000);
                }
            }
        })
    })
    $('.trucks-cancel').on('click',function(){
        let wb_no = $('.information-label').eq(3).data('id');
        $.ajax({
            type:'post',
            url: jkas.url('/wxxcx/hllEOrderCancelReason'),
            data:{
                nonce_str:parseInt(Math.random() * (1000000 - 100000 + 1) + 100000),
                order_display_id:wb_no
            },
            dataType: 'json',
            success: function (res) {
                if(res.code==10){
                    let htm = '<ul class="cancel-list">';
                    if(res.data.length==1){
                        let sub_cat = res.data[0].sub_cat;
                        for(i in sub_cat){
                            let str = '',htm2='';
                            if(sub_cat[i].sub_name=='其他'){
                                str='onclick="$(this).siblings(\'.cancel-reason\').show()"';
                                htm2='<textarea class="cancel-reason"></textarea>'
                            }
                            htm+=`<li class="reason-item"><label class="check-box" `+str+`>`+sub_cat[i].sub_name+`
                                    <input class="check-input" type="radio" name="sub_id" value="`+sub_cat[i].sub_id+`" data-reason="`+sub_cat[i].sub_name+`">
                                    <span class="check-item"><em class="check-spot"></em></span>
                                    </label>
                                    `+htm2+`
                                </li>`
                        }
                    }else{

                    }
                    htm+='</ul>'
                    layer.open({
                        title:'取消原因',
                        btn:['取消','确定取消订单'],
                        area: ['400px', 'auto'],
                        shadeClose:true,
                        content:htm,
                        btn2:function(){
                            let reason = $('input[name=sub_id]:checked').data('reason')=='其他'?$('.cancel-reason').val():$('input[name=sub_id]:checked').data('reason');
                            if(reason){
                                orderCancel($('.information-label').eq(3).data('wb'),$('input[name=sub_id]:checked').val(),reason)
                            }
                        }
                    })
                }
            }
        })
    })
    $('#selective input,#selective .icon').on('click', function () {
        modalFun.location.selectAddr('send',$('#selective').find("input[name=s_address_id]").val());
    })
    $('#filling input,#filling .icon').on('click', function () {
        modalFun.location.selectAddr('shou',$('#filling').find("input[name=r_address_id]").val());
    })
    $('#volume').on('click', function () {
        $('.volume-box').toggle()
    })
    $('.volume-btn').on('click', function () {
        var volume = (Number($('#length').val()/100 * $('#width').val()/100 * $('#height').val()/100)).toFixed(2);
        $('#volumeResult').val(volume);
        $('.volume-box').hide();
    })
    $('input[name="home_delivery_on"]').on('click',function(){
        if($(this).val()==1){
            $('input[name="pickup_begin_time"]').parents('.form-item').show()
            $.ajax({
                type: 'post',
                url: jkas.url('/wxxcx/getPickTime'),
                dataType: 'json',
                success: function (res) {
                    var arr = res.list;
                    $(arr).each(function (i, item) {
                        $(item.time_list).each(function (j, option) {
                            if(option.is_lose != 1){
                                $('#day input').val(item.name+timeFormat(item.time, 'MM.dd')+' '+option.time_area)
                                $('input[name="pickup_begin_time"]').val(option.pickup_begin_time)
                                $('input[name="pickup_end_time"]').val(option.pickup_end_time)
                                return false;
                            }
                        })
                        if($('#day input').val()){
                            return false;
                        }
                    })
                }
            })
        }else{
            $('input[name="pickup_begin_time"]').parents('.form-item').hide()
            $('#day input').val('')
            $('input[name="pickup_begin_time"]').val('')
            $('input[name="pickup_end_time"]').val('')
        }
    })
    // $('input[name="site_delivery"]').on('click',function(){
    //     if($(this).val()==2){
    //         $('.all').show()
    //         if($('#read').is(':checked')&&$('input[name="freight_pre"]').val()!=0){
    //             $('.submit').removeClass('miss');
    //         }else{
    //             $('.submit').addClass('miss');
    //         }
    //     }else{
    //         $('.all').hide()
    //         $('.submit').removeClass('miss');
    //     }
        
    // })
    $('#day').on('click', function (e) {
        e.stopPropagation();
        $('.time-box').toggle();
        $('.slot-box').remove();
        $.ajax({
            type: 'post',
            url: jkas.url('/wxxcx/getPickTime'),
            dataType: 'json',
            success: function (res) {
                var html = '';
                var arr = res.list;
                $(arr).each(function (i, item) {
                    var htm = '',
                        clName = i == 0 ? "act" : '',
                        none = i != 0 ? 'style="display: none;"' : '';
                    html += '<p class="day ' + clName + '">' + item.name + '<br><span class="date">' + timeFormat(item.time, 'MM.dd') + '</span></p>';
                    htm += '<div class="slot-box" ' + none + '>';
                    $(item.time_list).each(function (j, option) {
                        if(option.is_lose != 1){
                            htm += '<p class="time-slot" data-start="'+option.pickup_begin_time+'" data-end="'+option.pickup_end_time+'">' + option.time_area + '</p>';
                        }
                        var pass = option.is_lose == 1 ? 'pass' : '';
                    })
                    htm += '</div>';
                    $('.day-box').after(htm);
                })
                $('.day-box').empty().append(html)
                $('.day-box .day').on('click', function () {
                    $(this).addClass('act').siblings().removeClass('act');
                    if ($(this).index() == 0) {
                        $('.slot-box').hide().eq(2).show();
                    } else if ($(this).index() == 1) {
                        $('.slot-box').hide().eq(1).show();
                    } else {
                        $('.slot-box').hide().eq(0).show();
                    }
                })
            }
        })
    })
    $('.time-box').on('click','.day', function (e) {
        e.stopPropagation();
        $(this).addClass('act').siblings().removeClass('act');
    })
    $('.time-box').on('click', '.time-slot', function () {
        $(this).addClass('act').siblings().removeClass('act')
        var time = $('.time-box .day.act').text() + ' ' + $(this).text()
        $(this).parents('.time-box').siblings('#day').children('input[type="text"]').val(time)
        $('input[name="pickup_begin_time"]').val($(this).data('start'))
        $('input[name="pickup_end_time"]').val($(this).data('end'))
        $('.time-box').toggle()
    })
    // $('input[name="weight"],input[name="volume"],input[name="express_item_qty"]').on('blur',function(){
    //     if($('input[name=site_delivery]').val()==1){
    //         getFreight(1)
    //         getFreight(2)
    //     }else{
    //         getFreight(1)
    //     }
    // })
    var guaranteeFee=0;
    $('input[name="guarantee_value"]').on('blur',function(){
        var that = $(this)
        if($(this).val()>200000){
            layer.msg('保价不可超过20万！')
            $(this).val(200000)
        }else{
            $.ajax({
                type:'post',
                url:jkas.url('/wxxcx/getGuaranteeFee'),
                dataType:'json',
                data:{guarantee_value:that.val()},
                success:function(res){
                    if(res.code==10){
                        guaranteeFee = res.guarantee_fee;
                        that.siblings('span').remove();
                        that.after('<span style="color:#e75d5d;font-size:16px;position: absolute;right: 10px;top: 10px;">(保费：'+res.guarantee_fee+')</span>');
                    }else{
                        that.siblings().remove()
                        layer.msg(res.rep_msg);
                    }
                }
            })
        }
    })
    $('body').on('click', '.radio', function () {
        var $this = $(this);
        if ($(this).parents('.select-box').data('type') == 'send') {
            $('input[name="s_address_id"]').val($(this).children('input').val());
            $('#sName').val($(this).children('.name').children('span').text());
            $('#sPhone').val($(this).children('.phone').text());
            $('#sAddress').val($(this).find('.city').text());
            $('#sAddress2').val($(this).find('.details').text());
        } else {
            $('input[name="r_address_id"]').val($(this).children('input').val());
            $('#rName').val($(this).children('.name').children('span').text());
            $('#rPhone').val($(this).children('.phone').text());
            $('#rAddress').val($(this).find('.city').text());
            $('#rAddress2').val($(this).find('.details').text());
        }
        $('.layui-layer-close').trigger('click')
        // if($('input[name=site_delivery]').val()==1){
        //     getFreight(1)
        //     getFreight(2)
        // }else{
        //     getFreight(1)
        // }
    })
    $('body').on('click','#agreement,.agreement',function(){
        var lc_id = $(this).data('lc_id')?$(this).data('lc_id'):'';
        layer.open({
            area: ['800px','500px'],
            type: 2,
            title: false,
            closeBtn: 2,
            shadeClose: true,
            content: jkas.url('/wxxcx/expressServiceAgreement') + '?lc_id=' + lc_id
        });
    })
    // $('body').on('click','input[name=lc_id]',function(){
    //     $('.fee').hide();
    //     $(this).parents('p').siblings('div').children().show();
    // })
    $('#read').on('click',function(){
        if($('input[name=site_delivery]').val()==1){
            getFreight(1)
            getFreight(2)
            getFreight(12)
        }else{
            getFreight(1)
        }
        if($('#read').is(':checked')&&$('input[name="freight_pre"]').val()!=0){
            $('.submit').removeClass('miss');
        }else{
            $('.submit').addClass('miss');
        }
    })
    var freight1=0,freight2=0,freight3=0,freHtml2='',freHtml='',freHtml3='';
    $('.submit').on('click', function () {
        if($(this).hasClass('miss')){
            return
        }
        if($('input[name="order_sn"]').val()!=''&&$('input[name="sale_plat"]').val()==''){
            layer.msg('订单号不为空，请填写关联平台！');
            return
        }
        var msg = '';
        $('.page .must-fill').each(function(i,item){
            var option =  $(item).parent().siblings('.form-input').children('input');
            if(option.attr('type')=='text'||option.attr('type')=='hidden'){
                if(option.val()==''){
                    msg='请填写'+$(item).attr('title');
                    return false;
                }else{
                    msg='';
                };
            }
        })
        if(msg!=''){
            layer.msg(msg);
            return
        }
        $('input[type="checkbox"]').each(function(i,item){
            if($(item).is(':checked')){
                $(item).val(1)
            }else{
                $(item).val(0)
            }
        })
        if($('input[name=site_delivery]').val()==1){
            getFreight(1)
            getFreight(2)
            getFreight(12)
        }else{
            getFreight(1)
        }
        var formData = $('.page').children('form').serializeArray();
        var ps1 = freight1==0?'待上门评估':'预估<span>费用</span>'+freight1+'元';
        var ps2 = freight2==0?'待上门评估':'预估<span>费用</span>'+freight2+'元';
        var ps3 = freight3==0?'待上门评估':'预估<span>费用</span>'+freight3+'元';
        let htm = `<div class="logistics_box">
                        <div><p style="margin-bottom:8px;"><label>
                        <input type="radio" name="lc_id" value="1">
                        <span><em></em></span>京东冷运（<span id="freight1">`+ps1+`</span>）</label>
                        </p><p class="agree"  style="margin-left: 20px;">我已阅读
                        <em class="agreement" data-lc_id="1">《快件服务协议》</em></p><div id="freHtml1">`+freHtml3+`</div></div>`+
                        // `<p class="tips" style="margin-bottom:16px;">注：系统维护中，暂时不能提供服务</p>`+
                        `<div style="margin-bottom:8px;border-top:1px solid #ededed;padding-top:16px;"><p>
                            <label><input type="radio" name="lc_id" value="2" checked>
                            <span><em></em></span>顺丰冷运（<span id="freight2">`+ps2+`</span>）</label></p>
                        <p class="agree" style="margin-left: 20px;">我已阅读
                        <em class="agreement" data-lc_id="2">《快件服务协议》</em></p><div id="freHtml2">`+freHtml2+
                        `</div></div>`+
                        `<div style="margin-bottom:8px;border-top:1px solid #ededed;padding-top:16px;"><p>
                            <label><input type="radio" name="lc_id" value="12">
                            <span><em></em></span>鑫源冷运（<span id="freight3">`+ps3+`</span>）</label></p><div id="freHtml3">`+freHtml+`</div></div>`+
                        `<p class="tips">注：以上费用以实际揽收为准</p></div>`
        layer.open({
            title:'请选择下单物流',
            area:['400px','500px'],
            content:htm,
            btn:['取消','下运单 >'],
            btn2:function(){
                var lc_id = $('input[name=lc_id]:checked').val()
                formData.push({name:'lc_id',value:$('input[name=lc_id]:checked').val()});
                console.log(formData);
                lc_id==1?formData.push({name:'freight_pre',value:freight1}):lc_id==2?formData.push({name:'freight_pre',value:freight2}):formData.push({name:'freight_pre',value:freight3});
                $.ajax({
                    type:'post',
                    url:jkas.url('/wxxcx/orderDeliveryXcx'),
                    data:formData,
                    dataType:'json',
                    success:function(res){
                        layer.msg(res.rep_msg)
                        if(res.code=='10'){
                            sessionStorage.setItem('waybillData',JSON.stringify(res.data));
                            setTimeout(function(){
                                window.location.href=jkas.url("/chain/odok")+'?lc_id='+lc_id
                            },800)
                        }
                    }
                })
            }
        })
    })
    $('.content').on('click',function(){
        if(!$(this).data('login')){
            layer.msg('请先登录')
            setTimeout(function(){
                location.href = jkas.url('/login')
            },2000)
        }
    })
    function getDefaultAddressXcx() {
        $.ajax({
            type:'post',
            url:jkas.url('/wxxcx/getDefaultAddressXcx'),
            dataType:'json',
            success:function(res){
                if(res.code==10){
                    if(!$.isEmptyObject(res.default_address)){
                        $('input[name="s_address_id"]').val(res.default_address.address_id);
                        $('#sName').val(res.default_address.consignee);
                        $('#sPhone').val(res.default_address.mobile);
                        $('#sAddress').val(res.default_address.p_cn+'-'+res.default_address.c_cn+'-'+res.default_address.d_cn+'-'+res.default_address.st_cn);
                        $('#sAddress2').val(res.default_address.address);
                    }
                    if(!$.isEmptyObject(res.send_default_address)){
                        $('input[name="r_address_id"]').val(res.send_default_address.address_id);
                        $('#rName').val(res.send_default_address.consignee);
                        $('#rPhone').val(res.send_default_address.mobile);
                        $('#rAddress').val(res.send_default_address.p_cn+'-'+res.send_default_address.c_cn+'-'+res.send_default_address.d_cn+'-'+res.send_default_address.st_cn);
                        $('#rAddress2').val(res.send_default_address.address);
                    }
                }
            }
        })
    }
    function getFreight(lc_id){
        if($('input[name="weight"]').val()!=''&&$('input[name="volume"]').val()!=''&&$('input[name="express_item_qty"]').val()!=''&&$('input[name="s_address_id"]').val()!=''&&$('input[name="r_address_id"]').val()!=''){
            $.ajax({
                type:'post',
                url:jkas.url('/wxxcx/calFreightPreXcx'),
                dataType:'json',
                data:{weight:$('input[name="weight"]').val(),
                    volume:$('input[name="volume"]').val(),
                    express_item_qty:$('input[name="express_item_qty"]').val(),
                    s_address_id:$('input[name="s_address_id"]').val(),
                    r_address_id:$('input[name="r_address_id"]').val(),
                    lc_id:lc_id,
                    home_delivery_on:$('input[name="home_delivery_on"]:checked').val(),
                    site_delivery:$('input[name="site_delivery"]:checked').val(),
                    xypackage:$('input[name=xypackage]').val(),
                    zcservice:$('input[name=zcservice]').is(':checked')?1:0,
                    xcservice:$('input[name=xcservice]').is(':checked')?1:0
                },
                success:function(res){
                    if(res.code==10){
                        freHtml2='',freHtml='',freHtml3='';
                        $('.cost').children().text(res.freight_pre)
                        lc_id==1?$('input[name="freight_pre"]').val((res.freight_pre-0).toFixed(2)):'';
                        if($('#read').is(':checked')){
                            $('.submit').removeClass('miss');
                        }
                        if(lc_id==1){
                            freight1=Number(res.freight_pre)+Number(res.pickup_fee)+Number(res.delivery_fee);
                            $('#freight1').html(freight1==0?'待上门评估':'预估<span>费用</span>'+freight1+'元');
                        }else if(lc_id==2){
                            freight2=Number(res.freight_pre)+Number(res.pickup_fee)+Number(res.delivery_fee);
                            $('#freight2').html(freight2==0?'待上门评估':'预估<span>费用</span>'+freight2+'元');
                        }else{
                            freight3=Number(res.price_data.accbj)+Number(res.price_data.accfw)+Number(res.price_data.accjh)+Number(res.price_data.accsh)+Number(res.price_data.accxc)+Number(res.price_data.accyf)+Number(res.price_data.acczc);
                            $('#freight3').html(freight3==0?'待上门评估':'预估<span>费用</span>'+freight3+'元');
                        }
                        if(freight1!=0&&lc_id==1){
                            res.freight_pre==0?'':freHtml3+='<p class="fee">运费：￥'+res.freight_pre+'</p>';
                            res.pickup_fee==0?'':freHtml3+='<p class="fee">揽收费：￥'+res.pickup_fee+'</p>';
                            res.delivery_fee==0?'':freHtml3+='<p class="fee">派送费：￥'+res.delivery_fee+'</p>';
                            $('#freHtml1').html(freHtml3)
                        }
                        if(freight2!=0&&lc_id == 2){
                            res.freight_pre==0?'':freHtml2+='<p class="fee">运费：￥'+res.freight_pre+'</p>';
                            res.pickup_fee==0?'':freHtml2+='<p class="fee">提货费：￥'+res.pickup_fee+'</p>';
                            res.delivery_fee==0?'':freHtml2+='<p class="fee">配送费：￥'+res.delivery_fee+'</p>';
                            $('#freHtml2').html(freHtml2)
                        }
                        if(freight3!=0&&lc_id == 12){
                            res.price_data.accjh!=0?freHtml+='<p class="fee">接货费：￥'+res.price_data.accjh+'</p>':'';
                            res.price_data.accsh!=0?freHtml+='<p class="fee">送货费：￥'+res.price_data.accsh+'</p>':'';
                            res.price_data.accyf!=0?freHtml+='<p class="fee">运 费：￥'+res.price_data.accyf+'</p>':'';
                            res.price_data.accfw!=0?freHtml+='<p class="fee">服务费：￥'+res.price_data.accfw+'</p>':'';
                            res.price_data.acczc!=0?freHtml+='<p class="fee">装车费：￥'+res.price_data.acczc+'</p>':'';
                            res.price_data.accxc!=0?freHtml+='<p class="fee">卸车费：￥'+res.price_data.accxc+'</p>':'';
                            res.price_data.accbj!=0?freHtml+='<p class="fee">报价费：￥'+res.price_data.accbj+'</p>':'';
                            $('#freHtml3').html(freHtml)
                        }
                    }else{
                        if(lc_id==1){
                            freight1=0;
                            $('#freight1').html('待上门评估');
                        }else if (lc_id==2){
                            freight2=0;
                            $('#freight2').html('待上门评估');
                        }else{
                            freight3=0;
                            $('#freight3').html('待上门评估');
                        }
                    }
                    if(res.rep_msg=='请先登录'){
                        location.href = jkas.url('/login')
                    }
                }
            })
        }
    }
    function getCityList(){
        $.ajax({
            type:'post',
            url:jkas.url('/wxxcx/hllECityList'),
            dataType:'json',
            data:{nonce_str:parseInt(Math.random() * (1000000 - 100000 + 1) + 100000)},
            success:function(res){
                if(res.code==10){
                    let htm ='';
                    for(let i =0;i<res.data.length;i++){
                        i==0?htm+='<span class="citys-item act" data-id="'+res.data[i].city_id+'">'+res.data[i].name+'</span>'
                        :htm+='<span class="citys-item" data-id="'+res.data[i].city_id+'">'+res.data[i].name+'</span>'   
                    }
                    $('.citys-name').append(htm)
                    getCityCar(res.data[0].city_id)
                }
            }
        })
    }
    function getCityCar(city_id){
        obj.city_id=city_id;
        $.ajax({
            type:'post',
            url:jkas.url('/wxxcx/hllECityInfo'),
            dataType:'json',
            data:{nonce_str:parseInt(Math.random() * (1000000 - 100000 + 1) + 100000),city_id:city_id},
            success:function(res){
                if(res.code==10){
                    let htm ='',items = res.data.vehicle_arr,arr = res.data.spec_req_arr;
                    obj.revision =  res.data.revision;
                    obj.order_vehicle_id = items[0].order_vehicle_id;
                    getEvaluation()
                    items.length>4?$('.trucks-box .icon-arrow-right').addClass('move'):$('.trucks-box .icon-arrow-right').removeClass('move');
                    for(let i =0;i<items.length;i++){
                        let str = i==0?'style="display:none;"':'';
                        htm+=`<li class="trucks-item" data-id="`+items[i].order_vehicle_id+`">
                                    <img class="trucks-img" src="`+items[i].img_url_high_light+`" alt="">
                                    <p>`+items[i].name+`</p>
                                    <div class="transparent"`+str+`></div>
                                    <div class="trucks-tip">
                                    `+items[i].vehicle_price_text_item.text_weight+`<br>
                                    长宽高：`+items[i].vehicle_price_text_item.text_size+`<br>
                                    载货体积：`+items[i].vehicle_price_text_item.text_volume+`</div></li>`;
                    }
                    $('#trucksList').empty().append(htm)
                    htm='';
                    for(let i = 0;i<arr.length;i++){
                        htm+=`<label class="check-box">
                        <input class="check-input" type="checkbox" name="type" value="`+arr[i].type+`">
                        <span class="check-item"><em class="check-spot"></em></span>`+arr[i].name+`（`+arr[i].desc+`）</label>`
                    }
                    $('#additionalDemand').empty().append(htm)
                }
            }
        })
    }
    function getEvaluation(){
        if($('.icon-iconfonticonfontwarn').length>=2){
            $.ajax({
                type:'post',
                url:jkas.url('/wxxcx/hllEOrderPriceCalculate'),
                dataType:'json',
                async: false,
                data:{nonce_str:parseInt(Math.random() * (1000000 - 100000 + 1) + 100000),
                    city_id:obj.city_id,
                    city_info_revision:obj.city_info_revision,
                    order_vehicle_id:obj.order_vehicle_id,
                    std_tag_arr:JSON.stringify(obj.std_tag_arr),
                    spec_req_arr:JSON.stringify(obj.spec_req_arr),
                    lat_lon_arr:JSON.stringify(obj.lat_lon_arr)
                },
                success:function(res){
                    if(res.code==10){
                        obj.total_price_fen = res.data.total_price_fen;
                        $('#totalPrice').text('￥'+(res.data.total_price_fen/100).toFixed(2))
                        let htm = '';
                        for(let i = 0;i<res.data.order_price_arr.length;i++){
                            let str = '';
                            switch(res.data.order_price_arr[i].type){
                                case 1:
                                    str='起步价（'+res.data.order_vehicle_name+'）'
                                    break;
                                case 2:
                                    str='超过里程（'+(res.data.exceed_distance/1000).toFixed(2)+'公里）'
                                    break;
                                case 3:
                                    str='拉拉劵'
                                    break;
                                // case 4:
                                //     str='额外需求产生的费用'
                                //     break;
                                case 5:
                                    str='小费'
                                    break;
                                case 6:
                                    str='规格'
                                    break;    
                                case 7:
                                    str='平台订单补贴'
                                    break;
                                case 8:
                                    str='额外费用'
                                    break;

                            }
                            if(str!=''){
                                htm+=`<p class="price-item">`+str+`<span class="price-subtotal">¥`+(res.data.order_price_arr[i].price_fen/100).toFixed(2)+`</span></p>`
                            }
                        }
                        for(let i = 0;i<res.data.spec_req_price_arr.length;i++){
                            htm+=`<p class="price-item">`+res.data.spec_req_price_arr[i].name+`<span class="price-subtotal">¥`+(res.data.spec_req_price_arr[i].price_fen/100).toFixed(2)+`</span></p>`
                        }
                        htm+='<p class="price-item">货物保障（0元最高保5万）<span class="price-subtotal">¥0</span></p>'
                        $('.price-details-box').empty().html(htm)
                    }
                }
            })
        }
    }
    function getOrderDetail(wb_no){
        setTimeout(function(){
            $.ajax({
                type:'post',
                    url:jkas.url('/wxxcx/hllEOrderDetail'),
                    dataType:'json',
                    data:{
                        nonce_str:parseInt(Math.random() * (1000000 - 100000 + 1) + 100000),
                        wb_no:wb_no
                    },
                    success:function(res){
                        if(res.code==10){
                            if(res.data==[]||res.data==''){
                                getOrderDetail(wb_no)
                            }else{
                                $('.logistics-order').show().siblings().hide()
                                $('#footer').hide()
                                $('#cancel').show()
                                let label = $('.information-label'),data = res.data.order_detail_item.order_item;
                                label.eq(1).after(data.create_time);
                                label.eq(3).data('id',data.order_display_id).data('wb',res.wb_no).after(data.order_display_id);
                                label.eq(4).after(res.sale_plat);
                                label.eq(5).after('￥'+(data.price_fen/100).toFixed(2));
                                $('.price-table .price-subtotal').eq(0).text('总计￥'+(data.price_fen/100).toFixed(2))
                                label.eq(7).after(data.vehicle_type_name);
                                let remark = data.remark==''?'-':data.remark;
                                label.eq(9).after(remark);
        
                                let htm ='';
                                for(j in data.order_price_arr){
                                    let str = '';
                                    switch(data.order_price_arr[j].type){
                                        case 1:
                                            str='起步价'
                                            break;
                                        case 2:
                                            str='超过里程（'+(res.data.order_detail_item.exceed_distance/1000).toFixed(2)+'公里）'
                                            break;
                                        case 3:
                                            str='拉拉劵'
                                            break;
                                        case 5:
                                            str='小费'
                                            break;
                                        case 6:
                                            str='规格'
                                            break;    
                                        case 7:
                                            str='平台订单补贴'
                                            break;
                                        case 8:
                                            str='额外费用'
                                            break;
                                        case 15:
                                            str='货物保障（0元最高保5万）'
                                            break;
                                        case 24:
                                            str='其它'
                                            break;
                                    }
                                    if(j%2==0){
                                        htm+='<tr><td class="price-item">'+str+'<span class="price-subtotal">￥'+(data.order_price_arr[j].price_fen/100).toFixed(2)+'</span></td>'
                                    }else{
                                        htm+='<td class="price-item">'+str+'<span class="price-subtotal">￥'+(data.order_price_arr[j].price_fen/100).toFixed(2)+'</span></td></tr>'
                                    } 
                                }
                                let str2 = '-',num=0;
                                for( i in data.spec_req_price_arr){
                                    str2+= data.spec_req_price_arr[i].name + ',';
                                    let judge = data.order_price_arr.length%2==0?i%2==0:i%2!=0;
                                    if(data.spec_req_price_arr[i].price_type!=0){
                                        num++;
                                        if(judge){
                                            htm+='<tr><td class="price-item">'+data.spec_req_price_arr[i].name+'<span class="price-subtotal">￥'+(data.spec_req_price_arr[i].price_fen/100).toFixed(2)+'</span></td>'
                                        }else{
                                            htm+='<td class="price-item">'+data.spec_req_price_arr[i].name+'<span class="price-subtotal">￥'+(data.spec_req_price_arr[i].price_fen/100).toFixed(2)+'</span></td></tr>'
                                        } 
                                    }
                                }
                                label.eq(8).after(str2);
                                (data.order_price_arr.length+num)%2==0?'':htm+='<td class="price-item"></td></tr>';
                                $('.price-item').eq(0).parent().after(htm);
        
                                let htm2 = '';
                                for(k in data.addr_info_arr){
                                    htm2+=`<div class="address-box">
                                                `+data.addr_info_arr[k].name+`
                                                <p class="address-details">`+data.addr_info_arr[k].addr+`<br>`+res.data.order_detail_item.contact_phone_no+`</p>
                                            </div>`
                                    k==(data.addr_info_arr.length-1)?'':htm2+='<div class="address-line"><span class="line-triangle"></span><span class="line-triangle white"></span></div>';
                                }
                                if(data.addr_info_arr.length>2){
                                    data.addr_info_arr.length>4?$('.order-address .iconfont').show():'';
                                    $('#addressList').parent().addClass('address-slide')
                                    $('.order-address').css('padding-left','0')
                                }else{
                                    $('.order-address .iconfont').hide()
                                    $('#addressList').parent().removeClass('address-slide')
                                }
                                $('#addressList').append(htm2)
                            }
                        }
                    }
            })
        },3000)
    }
    function orderCancel(wb_no,reason_id,reason){
        $.ajax({
            type:'post',
            url: jkas.url('/wxxcx/hllEOrderCancel'),
            data:{
                nonce_str:parseInt(Math.random() * (1000000 - 100000 + 1) + 100000),
                wb_no:wb_no,
                reason_id:reason_id,
                reason:reason
            },
            dataType: 'json',
            success: function (res) {
                layer.msg(res.rep_msg)
                if(res.code==10){
                    location.reload()
                }
            }
        })
    }
})